import './Markdown.css';
export var frontmatterTable = '_14dgpdh1-3-15-1';
export var wrapper = '_14dgpdh0-3-15-1';